<template>
    <header class="mx-auto mb-10 w-full max-w-7xl border-b-1 py-4">
        <nav class="w-full">
            <div class="flex items-center justify-between">
                <!-- Header logo -->
                <div class="flex">
                    <!-- <Tailwind /> -->
                    <nuxt-link
                        to="/"
                        class="flex self-center"
                    >
                        <img
                            src="/img/logo/logo_prazsky_ulicnik.svg"
                            alt="logo"
                            class="h-12"
                        />
                    </nuxt-link>
                </div>

                <!-- Mobile toggle -->
                <div class="md:hidden">
                    <button @click="drawer">
                        <svg
                            class="h-8 w-8 fill-current text-black"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>

                <!-- Navbar -->
                <div class="hidden md:block">
                    <ul class="flex space-x-8 text-sm">
                        <li class="pt-3">
                            <nuxt-link
                                to="/historie-ulic"
                                class="my-link source font-bold"
                            >
                                Historie ulic
                            </nuxt-link>
                        </li>
                        <li class="pt-3">
                            <nuxt-link
                                to="/prameny"
                                class="my-link source font-bold"
                            >
                                Prameny
                            </nuxt-link>
                        </li>
                        <li class="pt-3">
                            <nuxt-link
                                to="/prehledy"
                                class="my-link source font-bold"
                            >
                                Přehledy
                            </nuxt-link>
                        </li>

                        <li class="pt-3">
                            <nuxt-link
                                to="/o-aplikaci"
                                class="my-link source font-bold"
                            >
                                O aplikaci
                            </nuxt-link>
                        </li>

                        <li class="mt-1 mr-0">
                            <nuxt-link
                                to="/vyhledavani"
                                class="app-search-btn"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    viewBox="0 0 29.407 30.031"
                                >
                                    <g
                                        id="Component_117_17"
                                        data-name="Component 117 – 17"
                                        transform="translate(1.5 1.5)"
                                    >
                                        <circle
                                            id="Ellipse_97"
                                            data-name="Ellipse 97"
                                            cx="9.677"
                                            cy="9.677"
                                            r="9.677"
                                            fill="#fff"
                                            stroke="#000"
                                            stroke-linejoin="round"
                                            stroke-width="3"
                                        />
                                        <line
                                            id="Line_276"
                                            data-name="Line 276"
                                            x2="10.613"
                                            y2="10.613"
                                            transform="translate(16.233 16.857)"
                                            fill="none"
                                            stroke="#000"
                                            stroke-linejoin="round"
                                            stroke-width="3"
                                        />
                                    </g>
                                </svg>
                            </nuxt-link>
                        </li>

                        <li
                            class="app-help-btn mt-1"
                            @click="handleHelpClick"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                fill="currentColor"
                                class="bi bi-question-lg"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14"
                                />
                            </svg>
                        </li>
                    </ul>
                </div>

                <!-- Dark Background Transition -->
                <transition
                    enter-class="opacity-0"
                    enter-active-class="ease-out transition-medium"
                    enter-to-class="opacity-100"
                    leave-class="opacity-100"
                    leave-active-class="ease-out transition-medium"
                    leave-to-class="opacity-0"
                >
                    <div
                        v-show="isOpen"
                        class="fixed inset-0 z-10 transition-opacity"
                        @keydown.esc="isOpen = false"
                    >
                        <div
                            class="absolute inset-0 bg-black opacity-50"
                            tabindex="0"
                            @click="isOpen = false"
                        />
                    </div>
                </transition>

                <!-- Drawer Menu -->
                <aside
                    class="fixed top-0 left-0 z-30 h-full w-64 transform overflow-auto bg-white p-5 transition-all duration-300 ease-in-out"
                    :class="isOpen ? 'translate-x-0' : '-translate-x-full'"
                >
                    <div class="close">
                        <button
                            class="text-bla absolute top-0 right-0 mt-4 mr-4 text-black"
                            @click="isOpen = false"
                        >
                            <svg
                                class="h-6 w-6"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <span
                        class="border-bx flex w-full items-center p-4"
                        @click="isOpen = false"
                    >
                        <!-- <Tailwind /> -->
                    </span>

                    <ul class="divide-yyZ">
                        <li class="flex justify-center">
                            <nuxt-link
                                to="/historie-ulic"
                                class="my-link source my-2 inline-block font-bold"
                                @click="isOpen = false"
                            >
                                Historie ulic
                            </nuxt-link>
                        </li>
                        <li class="flex justify-center">
                            <nuxt-link
                                to="/prameny"
                                class="my-link source my-2 inline-block font-bold"
                                @click="isOpen = false"
                            >
                                Prameny
                            </nuxt-link>
                        </li>
                        <li class="flex justify-center">
                            <nuxt-link
                                to="/prehledy"
                                class="my-link source my-2 inline-block font-bold"
                                @click="isOpen = false"
                            >
                                Přehledy
                            </nuxt-link>
                        </li>
                        <li class="flex justify-center">
                            <nuxt-link
                                to="/o-aplikaci"
                                class="my-link source my-2 inline-block font-bold"
                                @click="isOpen = false"
                            >
                                O aplikaci
                            </nuxt-link>
                        </li>

                        <li class="mt-1 mr-0 flex justify-center">
                            <nuxt-link
                                to="/vyhledavani"
                                class="app-search-btn"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    viewBox="0 0 29.407 30.031"
                                >
                                    <g
                                        id="Component_117_17"
                                        data-name="Component 117 – 17"
                                        transform="translate(1.5 1.5)"
                                    >
                                        <circle
                                            id="Ellipse_97"
                                            data-name="Ellipse 97"
                                            cx="9.677"
                                            cy="9.677"
                                            r="9.677"
                                            fill="#fff"
                                            stroke="#000"
                                            stroke-linejoin="round"
                                            stroke-width="3"
                                        />
                                        <line
                                            id="Line_276"
                                            data-name="Line 276"
                                            x2="10.613"
                                            y2="10.613"
                                            transform="translate(16.233 16.857)"
                                            fill="none"
                                            stroke="#000"
                                            stroke-linejoin="round"
                                            stroke-width="3"
                                        />
                                    </g>
                                </svg>
                            </nuxt-link>
                        </li>

                        <li
                            class="mt-1 flex justify-center"
                            @click="handleHelpClick"
                        >
                            <span class="app-help-btn">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    class="bi bi-question-lg"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14"
                                    />
                                </svg>
                            </span>
                        </li>
                    </ul>
                </aside>
            </div>
        </nav>
    </header>
</template>

<script setup lang="ts">
const isOpen = ref(false)

const store = useMainStore()

function drawer() {
    isOpen.value = !isOpen.value
}

// Watch isOpen to set/remove body overflow
watch(
    isOpen,
    val => {
        if (import.meta.client) {
            if (val) {
                document.body.style.setProperty("overflow", "hidden")
            } else {
                document.body.style.removeProperty("overflow")
            }
        }
    },
    { immediate: true }
)

// Handle ESC key to close drawer
function handleKeydown(e: KeyboardEvent) {
    if (e.key === "Escape" && isOpen.value) {
        isOpen.value = false
    }
}

function handleHelpClick() {
    store.appHelpActive = !store.appHelpActive
}

onMounted(() => {
    document.addEventListener("keydown", handleKeydown)
})

onUnmounted(() => {
    document.removeEventListener("keydown", handleKeydown)
})
</script>

<style lang="scss" scoped></style>
